import { ref } from "vue";

const KIOSK_STORAGE_KEY = "kioskModeActive";
const KIOSK_ALLOWED_ROUTE_NAMES = ["visitors", "delays"] as const;

const isKioskModeActive = ref(false);
let hasHydrated = false;

const canUseSessionStorage = () => {
  return typeof window !== "undefined" && window.sessionStorage !== undefined;
};

const readKioskState = (): boolean => {
  if (!canUseSessionStorage()) return false;
  return sessionStorage.getItem(KIOSK_STORAGE_KEY) === "true";
};

const persistKioskState = () => {
  if (!canUseSessionStorage()) return;
  sessionStorage.setItem(KIOSK_STORAGE_KEY, String(isKioskModeActive.value));
};

const hydrateKioskState = () => {
  if (hasHydrated) return;
  isKioskModeActive.value = readKioskState();
  hasHydrated = true;
};

const isKioskRoute = (path: string) => {
  return path.startsWith("/visitors") || path.startsWith("/delays");
};

const activateKioskMode = () => {
  isKioskModeActive.value = true;
  persistKioskState();
};

const deactivateKioskMode = () => {
  isKioskModeActive.value = false;
  persistKioskState();
};

const syncKioskModeFromStorage = () => {
  isKioskModeActive.value = readKioskState();
};

const useKioskMode = () => {
  hydrateKioskState();

  return {
    isKioskModeActive,
    isKioskRoute,
    activateKioskMode,
    deactivateKioskMode,
    syncKioskModeFromStorage,
    KIOSK_ALLOWED_ROUTE_NAMES,
  };
};

export default useKioskMode;